import comp from "./SupervisorComment";
export default comp;
